import { createContext, useState } from 'react';
import type { ICorreiosProvider, IToken, ICorreios } from './interface';
import type { CreateTicketResponse } from 'interfaces/zendesk';

export const TokenContext = createContext<ICorreios | undefined>(undefined);

export const TokenContextProvider = ({ children }: ICorreiosProvider) => {
  const [token, setToken] = useState<IToken | undefined>(undefined);
  const [tokenColeta, setTokenColeta] = useState<string>('');
  const [area, setArea] = useState<string>('');
  const [brandId, setBrandId] = useState<number | null>(null);
  const [createdTicket, setCreatedTicket] = useState<CreateTicketResponse>();

  const handleSetToken = (token: IToken | undefined) => {
    setToken(token);
  };

  const handleSetTokenColeta = (token: string) => {
    setTokenColeta(token);
  };

  const handleSetArea = (area: string) => {
    setArea(area);
  };

  const handleSetBrandId = (brandId: number | null) => {
    setBrandId(brandId);
  };

  const handleSetNewTicketData = (value: CreateTicketResponse) => {
    setCreatedTicket(value);
  };

  return (
    <TokenContext.Provider
      value={{
        token,
        handleSetToken,
        tokenColeta,
        handleSetTokenColeta,
        area,
        handleSetArea,
        brandId,
        handleSetBrandId,
        createdTicket,
        handleSetNewTicketData,
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};
